import React from "react";
import DataDisplay from "../../../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

const renderCard = ({ value, label, change, raw_data_link = "" }) => {
  if (value == undefined) return null;
  return (
    <div className="avg-visits-scorecards__card">
      <DataDisplay
        key={label}
        value={value}
        label={label}
        type="default"
        toolTipContent={
          value >= 100000
            ? "Raw data is not available, if the number of visits more than 100,000"
            : null
        }
        toolTipId={label}
        url={raw_data_link}
        disableAnimation
        changeProps={{ changeValue: change / 100, showBorder: true }}
      />
    </div>
  );
};

export const ScoreCards = () => {
  const totalData = useSelector((state) => state.averageNumberOfVisitsPerClient.totalData);

  const scoreCards = Object.keys(totalData).map((key) => totalData[key]);

  const row1 = scoreCards.slice(0, 2);
  const row2 = scoreCards.slice(2);

  return (
    <div data-testid="scorecards" className="avg-visits-scorecards">
      <div className="avg-visits-scorecards__row">{row1.map(renderCard)}</div>
      {row2.length > 0 && <div className="scorecards">{row2.map(renderCard)}</div>}
    </div>
  );
};
export default ScoreCards;
